import { render } from "./PatientRecordView.vue?vue&type=template&id=56e6cc04&scoped=true"
import script from "./PatientRecordView.vue?vue&type=script&lang=js"
export * from "./PatientRecordView.vue?vue&type=script&lang=js"

import "./PatientRecordView.vue?vue&type=style&index=0&id=56e6cc04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6cc04"]])

export default __exports__